import { Modal } from 'antd';

import styled from 'styled-components';

export const ModalContainer = styled(Modal)<{ isConfirm?: boolean }>`
  .ant-modal-body {
    ${({ isConfirm }) => (isConfirm ? '' : 'height: 500px')};
    overflow-y: auto;
  }
`;

export const Container = styled.div`
  p {
    font-size: 14px;
    font-weight: 500;
    color: #202020;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: end;

  .ant-select {
    width: 320px;
    margin-bottom: 16px;
    .ant-select-selection-search-input {
      margin-left: 20px !important;
      width: calc(100% - 40px);
    }
  }

  .ant-select-arrow {
    pointer-events: unset;
  }
`;

export const ApplyMemberName = styled.div`
  display: flex;
  align-items: center;
`;

export const SuffixBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 500;

  p {
    color: #676767;
    cursor: pointer;
  }
`;

export const VerticalLine = styled.div`
  background-color: #cccccc;
  width: 1px;
  height: 16px;
  margin-right: 12px;
`;

export const DropdownWrapper = styled.div`
  padding: 20px;

  .ant-input-affix-wrapper {
    border-radius: 16px;
    margin-bottom: 8px;
  }

  .ant-picker {
    width: 124px;
  }

  .date-picker-wrapper {
    margin-bottom: 16px;
  }

  .search-button-wrapper {
    display: flex;
    justify-content: end;
  }
`;
